import * as Yup from "yup";

const TradeSchema = Yup.object().shape({
  algoKey: Yup.string().required("Algorithm is required"),
  availableBudget: Yup.number().typeError("Available budget must be a number"),
  tradeBudget: Yup.number()
    .required("Trade budget is required")
    .typeError("Trade budget must be a number"),
  budgetPerTrade: Yup.number()
    .required("Budget per trade is required")
    .typeError("Budget per trade must be a number"),
  stopProfit: Yup.number().typeError("Stop profit must be a number"),
  stopLoss: Yup.number().typeError("Stop loss must be a number"),
});

export default TradeSchema;
